import { LinkNavProps } from './LinkNav'
import { FullSideBarControlled } from '@my/ui'
import images from 'app/assets/images'

//type Link = { href: string; linkText: string; subText: string }

const linkList: LinkNavProps[] = [
  {
    to: '/',
    linkText: 'Home',
    icon: images.home,
  },
  {
    to: '/financial-profile',
    linkText: 'Financial Profile',
    icon: images.profile,
  },
  {
    to: '/financial-snapshot',
    linkText: 'Financial Snapshot',
    icon: images.FinancialSnapshot,
  },
  /* {
    to: '/recommendations',
    linkText: 'Financial recommendations & planning',
    icon: images['recommendation&Planning'],
    subItems: [
      {
        to: '/recommendations/planning',
        linkText: 'Planning',
      },
      {
        to: '/recommendations/recommendation',
        linkText: 'Recommendation',
      },
    ],
  }, */
  /* {
    to: '/investing',
    linkText: 'Investing',
    icon: images.investing,
  }, */
  {
    to: '/savvy',
    linkText: 'Savvy',
    icon: images.savvy,
  },
  {
    //to: '/recommendations',
    linkText: 'Financial Modules',
    disabled: true,
    //icon: images['recommendation&Planning'],
    subItems: [
      {
        linkText: 'Budget Analysis',
        icon: images?.spendingAnalysis,
        to: '/financial-spending',
      },
      {
        linkText: 'Financial Goals',
        icon: images?.financialGoals,
        to: '/financial-goals',
      },
      {
        linkText: 'Savings Forecast',
        icon: images?.cashFlow,
        to: '/financial-savingsforecast',
      },
      {
        linkText: 'Key Insights',
        icon: images?.keyInsight,
        to: '/key-insights',
      },
      {
        linkText: 'Recommendations',
        icon: images?.recommendation,
        to: '/recommendations',
      },
      {
        linkText: 'Financial Plan',
        icon: images?.financialPlan,
        to: '/financial-plan',
      },
      {
        linkText: 'Scenario Planning',
        icon: images?.scenarioPlanning,
        to: '/scenario-planning',
      },
      {
        linkText: 'Advisor Match',
        icon: images?.advisor,
        to: !true ? 'advisor-match' : 'stepOne',
      },
      {
        linkText: 'Investments',
        icon: images?.investWithUs,
        to: '/investments',
      },
    ]
  },//finacialsupport
  {
    to: 'https://wealthacademy.thezillennialadvisors.com/', //'https://thezillennialadvisors.substack.com/',
    linkText: `Wealth Academy by ZA`,
    icon: images.financialsupport,
    //subText: 'Market Pulse and Investment Spotlights',
    externalAnchor: true
  },
  {
    to: 'https://thezillennialadvisors.beehiiv.com/', //'https://thezillennialadvisors.substack.com/',
    linkText: `ZA's Pulse Newsletter`,
    icon: images['recommendation&Planning'],
    //subText: 'Market Pulse and Investment Spotlights',
    externalAnchor: true
  },
  {
    to: 'https://www.instagram.com/thezillennialadvisors/',
    linkText: 'Stay in touch!',
    icon: images.stayintouch,
    externalAnchor: true
  },
  /* {
    to: '/settings',
    linkText: 'Settings',
    icon: images.settings2,
  }, */
]

export function NavMenu({ isVisible, closeFn }: { isVisible: boolean; closeFn: () => void }) {
  return <FullSideBarControlled open={isVisible} navItems={linkList} setOpen={closeFn} />
}
